'use strict';

// var localStorage = window.localStorage;
import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/web.timers.js";
export default {
  name: 'PurchaseTokens',
  components: {},
  props: {},
  watch: {
    "$store.state.proMembership": function $storeStateProMembership(newValue) {
      if (newValue === true) {
        this.$store.commit('updateShowPurchaseTokensPage', false);
      }
    }
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  } // if (window.getDigitalGoodsService) {
  //   this.error = 'top'
  //   var service = await window.getDigitalGoodsService("https://play.google.com/billing");
  //   service.consume('kejbkockigmmgbhmicljmgok.AO-J1OyGjpQMAHV0LtDNDN4CFcZ6qjn28bpXCE45ogBgAO0EH7RKdJ56_99ao0s5Dlrq0ZCT-wW1_y_bHcYlR_7gfN0ielFqkPadu7zJHqZmXQ41bArN_ZE')
  //   service.consume('jimfhmocfeemjdhohcgjfalo.AO-J1Ox0f5e9BRg08B7kKQHEPjZ_cjiMGAlZmG93jaoKg0pvbp9yp0dXkbKYtBDlDSyQjv7-hQSKJc_-IQufAa1zoXi6nisq2ld-Y-oUY1m-kvlV2eIdIGI')

  // }
  ,
  methods: {
    purchaseTokens: function purchaseTokens(token_package) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var service, details, paymentMethodData, request, paymentResponse, purchaseToken, paymentComplete, userToken, axios, qs, data, config, localThis;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!('getDigitalGoodsService' in window)) {
                _context4.next = 28;
                break;
              }
              _this.error = 'top';
              _context4.next = 4;
              return window.getDigitalGoodsService("https://play.google.com/billing");
            case 4:
              service = _context4.sent;
              //  service.consume('opapbklkjaamhagddmcapbkn.AO-J1OxpgH42HFD2TiUDCPDI2AXPupOO001-bEuqLzwm_ZfsaRg2rv8FupnYii0wQgWTvepBbbg5aCqhBB7AQqpR2U2-AK9SfoHH7tAw1alZcU0DVL3029s')
              _this.error = 'service';
              _context4.next = 8;
              return service.getDetails([token_package]);
            case 8:
              details = _context4.sent;
              _this.error = 'details';
              _this.ResponseFromPurchase = JSON.stringify(details);
              _this.error = JSON.stringify(details);
              // const item = details[0];
              paymentMethodData = [{
                supportedMethods: 'https://play.google.com/billing',
                data: {
                  sku: token_package //item.itemId,
                }
              }];
              request = new PaymentRequest(paymentMethodData);
              _this.error = 'requested';
              _context4.next = 17;
              return request.show();
            case 17:
              paymentResponse = _context4.sent;
              _this.ResponseFromPurchase = JSON.stringify(paymentResponse);
              _this.error = _this.ResponseFromPurchase;
              purchaseToken = paymentResponse.details.purchaseToken;
              // const axios = require('axios');
              // const qs = require('qs');
              userToken = localStorage.getItem('security'); // const data = qs.stringify({
              //   'token': purchaseToken,
              //   'itemID': token_package,
              //   'type': 'token_package',
              //   'userToken': userToken
              // });
              // let config = {
              //   method: 'post',
              //   maxBodyLength: Infinity,
              //   url: 'https://us-central1-ai-voice-chat-358705.cloudfunctions.net/purchaseTokens',
              //   headers: {
              //     'Content-Type': 'application/x-www-form-urlencoded'
              //   },
              //   data: data
              // };
              // var localThis = this;
              // axios.request(config).then(async function (response) {
              axios = require('axios');
              qs = require('qs');
              data = qs.stringify({
                'itemID': token_package,
                'token': purchaseToken,
                'type': 'token_package',
                'userToken': userToken
              });
              config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://dev.aivitar.com/purchaseTokens',
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                },
                data: data
              };
              localThis = _this;
              axios.request(config).then( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(response) {
                  var quantity_of_tokens;
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        console.log('response', response);
                        if (token_package === '200_tokens') {
                          quantity_of_tokens = 200;
                        } else if (token_package === '600_tokens') {
                          quantity_of_tokens = 600;
                        } else if (token_package === '2500_tokens') {
                          quantity_of_tokens = 2500;
                        } else if (token_package === '5000_tokens') {
                          quantity_of_tokens = 5000;
                        }
                        _context2.next = 4;
                        return paymentResponse.complete('success');
                      case 4:
                        paymentComplete = _context2.sent;
                        service.consume(purchaseToken);
                        localThis.$store.commit('updateTokenScreen', {
                          title: 'Purchase Completed!',
                          subtitle1: 'You have purchased',
                          subtitle2: 'tokens!',
                          quantity: quantity_of_tokens,
                          buttonText: 'Close'
                        });
                        localThis.$store.commit('updateShowTokensFalling', true);
                        localThis.$store.commit('updateShowPurchaseTokens', false);
                        localThis.$store.dispatch('reportEvent', 'bought_tokens');
                        setTimeout(function () {
                          localThis.$store.commit('updateShowHearts', true);
                        }, 10);
                        setTimeout(function () {
                          localThis.$store.commit('updateShowHearts', false);
                        }, 4000);
                      case 12:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }())["catch"]( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(error) {
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        this.$store.commit("showSnackbarWarning", "There was an issue purchasing");

                        // REMOVE THIS LATER!!
                        // service.consume(purchaseToken);
                        _context3.next = 3;
                        return paymentResponse.complete('fail');
                      case 3:
                        paymentComplete = _context3.sent;
                        console.log(error);
                        console.log(paymentComplete);
                      case 6:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3, this);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());
              // let paymentComplete;
              // if (validatePurchaseOnBackend(purchaseToken)) {
              //   paymentComplete = await paymentResponse.complete('success');
              //   // Let user know their purchase transaction has successfully completed and been verified
              // } else {
              //   paymentComplete = await paymentResponse.complete('fail');
              //   // Let user know their purchase transaction failed to verify
              // }

              // this.paymentComplete = paymentComplete;

              // service.consume(purchaseToken);
            case 28:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    }
  },
  data: function data() {
    return {
      showMonthlyMembership: true,
      monthlySelected: false,
      ResponseFromPurchase: null,
      error: null
      // showApps: false,
    };
  }
};